import { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  SimpleGrid,
  HStack,
  IconButton,
  useToast,
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardSkeleton from '../DashboardSkeleton';
import { EmployeeCard } from '../../components/layout/EmployeeCard';
import { getEmployeeDataMe, getEmployees } from '../../hooks/employees';
import { Employee } from '../../utils/types';

const TeamDashboard = () => {
  let navigate = useNavigate();
  const { orgId } = useParams();
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [meEmployee, setMeEmployee] = useState<Employee>();
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  useEffect(() => {
    getEmployeesData(orgId);
    getMyEmployeeMeData(orgId);
  }, [orgId]);

  const getEmployeesData = async (id: any) => {
    setLoading(true);
    let response = await getEmployees(id);
    if (response.success === true && response.data) {
      setEmployees(response.data);
      console.log('team data', response.data);
      setLoading(false);
    } else {
      setEmployees(response.data);
      setLoading(false);
    }
    return response;
  };

  const getMyEmployeeMeData = async (id: any) => {
    setLoading(true);
    let response = await getEmployeeDataMe(id);
    if (response.success === true && response.data) {
      setMeEmployee(response.data);
      console.log('me data', response.data);
      setLoading(false);
    } else {
      toast({ title: 'Failed to load your employee data', status: 'error' });
      setLoading(false);
    }
    return;
  };

  const handleNewEmployeeClick = () => {
    // 2️⃣ Check access control
    console.log('meEmployee role', meEmployee);
    if (meEmployee?.role !== 'admin' && meEmployee?.role !== 'manager') {
      toast({
        title: 'Access Denied',
        description: 'Only Admins or Managers can add new team members.',
        status: 'error',
        duration: 3500,
        isClosable: true,
      });
      setLoading(false);
      return;
    }
    navigate(`/organization/${orgId}/employees/new`);
  };

  return (
    <Box p={8}>
      <HStack
        alignItems={'center'}
        justifyContent={'space-between'}
        flexWrap={'wrap'}
      >
        <Heading size="lg" mb={4}>
          Team Management
        </Heading>

        <Box position="fixed" bottom={6} right={6} zIndex={1000}>
          <IconButton
            colorScheme="green"
            aria-label="Add New Team Member"
            bgGradient="linear(to-r, green.600, green.500)"
            icon={<AddIcon />}
            onClick={handleNewEmployeeClick}
            size="lg"
            borderRadius="full"
            // px={6}
            py={4}
            shadow="2xl"
            _hover={{
              transform: 'scale(1.05)',
              shadow: 'xl',
              bgGradient: 'linear(to-r, green.700, green.500)',
            }}
            _active={{ transform: 'scale(0.98)' }}
          />
        </Box>
      </HStack>

      {loading && <DashboardSkeleton />}
      {!loading && orgId && (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
          {employees &&
            employees.length > 0 &&
            employees?.map((employee) => (
              <EmployeeCard
                key={employee?.id}
                employee={employee}
                meEmployee={meEmployee}
                orgId={orgId}
                employeesCount={employees.length}
              />
            ))}
        </SimpleGrid>
      )}
    </Box>
  );
};

export default TeamDashboard;
